/* global $ */
function updateContainer () {
  var windowHeight = $(window).height()
  var windowWidth = $(window).width()
  var imageWrapperHeight = $('.imageWrapper').height()

  $('.video, #hidevimeo, .videoWrapper').css('height', windowHeight + 'px')
  $('.videoWrapper, #hidevimeo ').css('width', windowWidth + 'px')
  $('.imageWrapper img').css('width', windowWidth / 2 + 'px')
  $('.imageWrapper').attr('data-end', 'top:' + (-imageWrapperHeight + windowHeight) + 'px')

  $('#hidevimeo').click(function () { $('html, body').stop().animate({ scrollTop: '1000' }, { duration: 1000 }) })
  $('#plus-info').click(function () { $('html, body').stop().animate({ scrollTop: '1000' }, { duration: 1000 }) })
}

export default updateContainer

$(window).resize(function () {
  updateContainer()// run on every window resize
})
